import { render, staticRenderFns } from "./HintButton.vue?vue&type=template&id=54aa65ba&scoped=true&"
import script from "./HintButton.vue?vue&type=script&lang=js&"
export * from "./HintButton.vue?vue&type=script&lang=js&"
import style0 from "./HintButton.vue?vue&type=style&index=0&id=54aa65ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aa65ba",
  null
  
)

export default component.exports